import styled, {css} from 'styled-components';
import {getColorFromTheme} from '../../../ui-utils';
import {down} from 'styled-breakpoints';
import {ifProp, switchProp} from 'styled-tools';

export const DropdownWrapper = styled.div<{$flatGroupPicker?: boolean}>`
  position: absolute;
  display: block;
  width: ${({$flatGroupPicker}) => ($flatGroupPicker ? '360px' : '100%')};
  max-width: 100%;
  top: ${({$flatGroupPicker}) =>
    $flatGroupPicker ? 'calc(100% + 8px)' : '120%'};
  border-radius: ${({$flatGroupPicker}) => ($flatGroupPicker ? '6px' : '8px')};
  border: solid 1px ${getColorFromTheme('borderDark')};
  background-color: ${getColorFromTheme('white')};
  box-shadow: ${({theme, $flatGroupPicker}) =>
    $flatGroupPicker ? 'none' : theme.elevation.level2};
  overflow: hidden;
  z-index: 9999;
`;

export const SelectionFooter = styled.div<{$flatGroupPicker?: boolean}>`
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: ${({$flatGroupPicker}) => ($flatGroupPicker ? '12px' : '16px')};
  border-top: 1px solid ${getColorFromTheme('borderDark')};
  border-radius: ${({$flatGroupPicker}) =>
    $flatGroupPicker ? '0 0 6px 6px' : '0 0 8px 8px'};
  background: ${getColorFromTheme('white')};
`;

export const FlatGroupPickerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 12px;
`;

export const FlatGroupPickerDivider = styled.div`
  width: 100%;
  border-top: 1px solid ${getColorFromTheme('borderLight')};
`;

export const FlatGroupPickerOptions = styled.div`
  display: flex;
  max-height: 152px;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
`;

export const FlatGroupPickerOption = styled.div<{selected?: boolean}>`
  display: flex;
  width: 100%;
  min-height: 32px;
  align-items: center;
  gap: 16px;
  padding: 2px 8px;
  border-radius: 8px;
  color: ${({selected}) =>
    selected ? getColorFromTheme('textDark') : getColorFromTheme('textBody')};
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: ${({selected}) => (selected ? 600 : 400)};
  line-height: 22px;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;

  &:hover {
    background: ${getColorFromTheme('backgroundDark')};
    color: ${getColorFromTheme('textDark')};
  }
`;

export const FlatGroupPickerLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FlatGroupPickerBadge = styled.span`
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 8px;
  background: ${getColorFromTheme('backgroundDark')};
  color: ${getColorFromTheme('textBody')};
  font-family: Graphik, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`;

export const FooterAction = styled.button<{primary?: boolean}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 8px 16px;
  border: ${({primary}) => (primary ? '1px solid transparent' : 'none')};
  border-radius: 8px;
  background: ${({primary}) =>
    primary ? getColorFromTheme('purple300') : 'transparent'};
  color: ${({primary}) =>
    primary ? getColorFromTheme('white') : getColorFromTheme('textBody')};
  font-family: Graphik, sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
`;

export const DropWrapper = styled.div`
  position: relative;
`;
export const Stack = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;
export const Wrapper = styled.div<{hasLabel?: boolean}>`
  position: relative;
  padding-top: ${({hasLabel}) => (hasLabel ? '26px' : '0')};
`;

export const ArrowIconWrapper = styled.span<{
  disabled?: boolean;
  $compact?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  svg {
    stroke: ${getColorFromTheme('textBody')};
    width: ${({$compact}) => ($compact ? '16px' : '20px')};
    height: ${({$compact}) => ($compact ? '16px' : '20px')};
    ${ifProp(
      'disabled',
      css`
        stroke: #bfbfd4;
      `,
    )};
  }
`;
export const GroupArrowWrapper = styled.span<{disabled?: boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    stroke: ${getColorFromTheme('textBody')};
    width: 16px;
    height: 16px;
    ${ifProp(
      'disabled',
      css`
        stroke: #bfbfd4;
      `,
    )};
  }
`;

export const AvatarWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DropdownHandler = styled.button<{
  open: boolean;
  height?: any;
  disabled?: boolean;
  state?: any;
  performance?: boolean;
  reportingStyling?: boolean;
  $compact?: boolean;
}>`
  outline: none;
  border-radius: ${({performance}) => (performance ? '10px' : '7px')};
  padding: ${({$compact}) => ($compact ? '5px 12px' : '5px 14px')};

  color: ${getColorFromTheme('textDark')};
  width: 100%;
  display: flex;
  align-items: center;
  min-height: ${(props: any) =>
    props.height
      ? props.height
      : props.$compact || props.reportingStyling
      ? '44px'
      : '52px'};
  background-color: ${getColorFromTheme('white')};
  transition: 200ms ease all;
  border: 1px solid;
  border-color: ${getColorFromTheme('borderDark')};

  ${switchProp('state', {
    error: css`
      border-color: ${getColorFromTheme('red400')};
    `,
  })}
  &:focus:not(:invalid) {
    outline: 0;
    border-color: ${getColorFromTheme('purple300')};
  }

  ${ifProp(
    'open',
    css`
      outline: 0;
      border-color: ${getColorFromTheme('purple300')};
    `,
  )};
  ${ifProp(
    'disabled',
    css`
      outline: 0;
      cursor: not-allowed;
      border-color: #cecede;
      color: #bfbfd4;
    `,
  )};
`;

export const HandlerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const OptionsWrapper = styled.span<{disabled?: boolean}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
  overflow: visible;
  &::-webkit-scrollbar {
    display: none;
  }
  p.greyOut {
    color: #5f5f8c;
    font-size: 14px;
    ${ifProp(
      'disabled',
      css`
        outline: 0;
        cursor: not-allowed;
        color: #bfbfd4;
      `,
    )};
  }
  ${down('sm')} {
    overflow-y: hidden;
  }
`;

export const OptionWrapper = styled.div<{active?: boolean}>`
  padding: 12px 16px;
  margin: 0 12px;
  border-radius: 8px;

  font-family: 'Graphik';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 170%;

  &:hover {
    background: #f6f6f8;
    p {
      color: #1e1e2f;
      font-weight: 500;
    }
  }

  p {
    color: ${getColorFromTheme('textBody')};

    font-family: 'Graphik';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 146%;
  }
  ${({active}) =>
    active &&
    css`
      p {
        // color: ${getColorFromTheme('blue500')}

        font-family: 'Graphik';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 170%;

        /* Text/Dark */
        color: #1e1e2f;
      }
    `}
`;
